import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {Profile, ProfileType, ProfileTypeTranslation} from "@model/profile";

@Component({
    selector: 'app-profile-item',
    templateUrl: './profile-item.component.html',
    styleUrls: ['./profile-item.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule]
})
export class ProfileItemComponent {

  @Input()
  profile: Profile;

  constructor() { }

  get profileTypeTranslation(): string {
    return ProfileTypeTranslation[this.profile.type];
  }

  get icon(): string {
    switch (this.profile.type) {
      case ProfileType.STAFFMEMBER:
        return 'supervisor_account';
      case ProfileType.PARENT:
        return 'family_restroom';
      case ProfileType.STUDENT:
        return 'boy';
      default:
        return 'supervisor_account';
    }
  }
}
